import { derived, writable } from "svelte/store"
import { config } from "./ConfigStore"

const defaults = {
	overlayVisible: false,
	context: '',
}

const createStateStore = () => {

	const { subscribe, set, update } = writable( { ...defaults } )

	const showOverlay = context =>
		update( state => {
			state.context = context
			state.overlayVisible = true
			return state
		} )

	const hideOverlay = () =>
		update( state => {
			state.context = ''
			state.overlayVisible = false
			return state
		} )

	return {
		subscribe,
		set,
		update,
		showOverlay,
		hideOverlay,
	}
}

export const state = createStateStore()
